/*----------------------------------------------------------------------------*\
    Link block
    Simple way of making whole blocks linkable
\*----------------------------------------------------------------------------*/

/**
 * Use strict as per:
 * http://ejohn.org/blog/ecmascript-5-strict-mode-json-and-more/
 */
'use strict';


/**
 * Check if oy object exists, otherwise create it
 */
var oy = oy || {};


/**
 * Jshint global references
 * Please define all third party plugins that you use to not break jshinting
 */



/*  Component
\*----------------------------------------------------------------------------*/

oy.linkBlock = {
    init: function () {
        if (oy.cutsMustard) {
            this.setupAll(document);
        }
    },

    setupAll: function ($context) {
        var self = this;

        if($context) {
            var $elements = $context.querySelectorAll('.js--link-block');

            for (var i = 0; i < $elements.length; ++i) {
                var $element = $elements[i];
                self.setupSingle($element);
            }
        }
    },

    setupSingle: function ($element) {
        if ($element && !$element.classList.contains('is-initialised')) {
            $element.classList.add('is-initialised');
            $element.classList.add('is-link');

            var $link = $element.querySelector('.js--link-block__link');

            if ($link && $link.getAttribute('href')) {
                var href = $link.getAttribute('href');
                $element.addEventListener('click', function(e) {
                    e.preventDefault();
                    window.location = href;
                }, false);
            }
        }
    }
};


window.addEventListener('load', function () {
    oy.linkBlock.init();
}, false);
